import { createContext } from 'react'
import type { Language } from './messages'

/**
 * La langue courante, SEULE, sans dictionnaire.
 *
 * `<Nombre>` n'a besoin que de la langue pour choisir son format. S'il la lisait par
 * `useI18n`, tout bundle qui affiche un nombre importerait `I18nProvider`, donc
 * `messages.ts` et ses six mille lignes — le site vitrine compris, qui a son propre
 * dictionnaire et n'affiche aucun écran de l'application.
 *
 * `I18nProvider` la pose pour l'application ; le site vitrine la pose depuis l'URL.
 * L'import de `Language` ci-dessus est un import de TYPE : il disparaît à la compilation.
 */
export const LangueCourante = createContext<Language>('fr')
